import "../../../resources/less/Constellation/Catalog/ChallengeTemplate.less";
import BaseCCatalogList from "../../components/Catalog/BaseCCatalogList";
import BaseCCatalogListFilters from "../../components/Catalog/BaseCCatalogListFilters";
import BaseMCatalogTemplate from "../../components/Catalog/BaseMCatalogTemplate";
import CCatalogListFilters from "./CCatalogListFilters";
import MCatalogTemplate from "./MCatalogTemplate";

export default class ConstellationCatalogList extends BaseCCatalogList {
  protected createTemplate(container: HTMLElement): BaseMCatalogTemplate {
    return new MCatalogTemplate(container);
  }

  protected createFilters(): BaseCCatalogListFilters {
    return new CCatalogListFilters(this);
  }
}

$(window).on("load", () => {
  new ConstellationCatalogList();
});
